import React, { Component } from 'react';

import {connect} from 'react-redux';

import {Config} from '../../util';
import NavMenuItem from './NavMenuItem';
import UserInfo from '../../components/userInfo';

// TODO: 메뉴 리스트 추가
const NavMenuArr = [
  {
    id:'SEARCH',
    title: 'Search'
  },
  {
    id: 'SCHEDULE',
    title: 'Schedule'
  },
  {
    id: 'FILE',
    title: 'File'
  },
  {
    id: 'DIVISION',
    title: "Division"
  },
  {
    id: 'DOWNLOADLOG',
    title: 'Download Log'
  },
  {
    id: 'SETTING',
    title: 'Setting'
  }
];

const SearchMenuArr = [
  {
    id:'SEARCH',
    title: 'Schedule'
  },
  {
    id: 'FILE',
    title: 'File'
  },
  {
    id: 'DIVISION',
    title: "Division"
  },
  {
    id: 'DOWNLOADLOG',
    title: 'Download Log'
  },
  {
    id: 'SETTING',
    title: 'Setting'
  }
]






class NavMenu extends Component {
  constructor(props){
    super(props);
    this.state={
      isItem: true
    };
    this.isItemToggle = this.isItemToggle.bind(this);
    this.ADMIN = sessionStorage.getItem('auth').includes('A') || sessionStorage.getItem('id').includes('master');
  }
  isItemToggle(){
    const {isItem} = this.state;
    this.setState({
      isItem: !isItem
    })
  }
  render(){
    const {isItem} = this.state;
    const {videoFlag, selectedMenu, handleLogoutClose} = this.props;
    let menuArr = Config.searchMode ? SearchMenuArr : NavMenuArr;
    menuArr = this.ADMIN ? Config.isSetting === "Y" || sessionStorage.getItem('id').includes('master') ? menuArr : menuArr.slice(0, -1) : menuArr.slice(0, -2);
    
    const navStyle = {
      top: '100px'
    }
    
    return (
      <div className="nav" style={!videoFlag ? navStyle : null}>
        {(!videoFlag || selectedMenu==="DIVISION") && <UserInfo handleLogoutClose={handleLogoutClose}/>}
        {isItem ? menuArr.map(menu => {
            return <NavMenuItem info={menu} key={menu.id}
              selected={ menu.id === this.props.selectedMenu} />
        }) : null}
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.selectedMenu,
    videoFlag: state.videoFlag,
  }
};

NavMenu = connect(mapStateToProps)(NavMenu);

export default NavMenu;


// WEBPACK FOOTER //
// ./src/components/menu/NavMenu.js